

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import TopBar from "./TopBar";
// import Logo from "../../../assets/Picture1.png";

// type Props = {
//   /** Optional legacy prop (kept for backwards-compat with Nurse 1/2/3 usage) */
//   nurseLabel?: "Nurse 1" | "Nurse 2" | "Nurse 3";
//   /** explicit base path to use, e.g. "/nurse-1", "/audiology", "/optometrist" */
//   basePath?: string;
//   /** label for the second tab, e.g. "Nurse 1", "Audiologist Screening", "Vision Screening" */
//   label?: string;
// };

// const NurseTopBar: React.FC<Props> = ({ nurseLabel, basePath, label }) => {
//   const navigate = useNavigate();

//   // Back-compat: if basePath/label not provided, fall back to nurseLabel
//   const effectiveLabel = label ?? nurseLabel ?? "Nurse 1";
//   const base =
//     basePath ??
//     ("/" + effectiveLabel.toLowerCase().replace(/\s+/g, "")); // "/nurse-1" or derived

//   const DASH = `${base}/dashboard`;
//   const HOME = base; // distinct path so only one tab is active

//   const tabs = ["Dashboard", effectiveLabel];
//   const linkForTab = (tab: string) => (tab === "Dashboard" ? DASH : HOME);

//   const onLogout = () => {
//     try {
//       sessionStorage.removeItem("accessToken");
//       localStorage.removeItem("accessToken");
//     } catch {}
//     navigate("/", { replace: true });
//   };

//   return (
//     <div className="app-header__inner">
//       <img className="app-header__logo" src={Logo} alt="Qavach" />
//       <div style={{ flex: 1 }}>
//         <TopBar tabs={tabs} linkForTab={linkForTab} onLogout={onLogout} />
//       </div>
//     </div>
//   );
// };

// export default NurseTopBar;



import React from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import Logo from "../../../assets/Picture1.png";
import "../../../center admin css/centerAdmin.css"

type Props = {
  /** Optional legacy prop (kept for backwards-compat with Nurse 1/2/3 usage) */
  nurseLabel?: "Nurse 1" | "Nurse 2" | "Nurse 3";
  /** explicit base path to use, e.g. "/nurse-1", "/audiology", "/optometrist" */
  basePath?: string;
  /** label for the second tab, e.g. "Nurse 1", "Audiologist Screening", "Vision Screening" */
  label?: string;
};

const NurseTopBar: React.FC<Props> = ({ nurseLabel, basePath, label }) => {
  const navigate = useNavigate();

  // Back-compat + explicit override
  const effectiveLabel = label ?? nurseLabel ?? "Nurse 1";

  // Prefer explicit basePath; otherwise derive for nurses only.
  // (The old derive-by-label caused wrong routes for Vision/Audiology.)
  const base =
    basePath ??
    (nurseLabel
      ? `/${nurseLabel.toLowerCase().replace(/\s+/g, "-")}` // "/nurse-1" etc.
      : "/nurse-1");

  // Where should the second tab go?
  const secondHref = (() => {
    if (base.startsWith("/audiology")) return "/audiology/screening";
    if (base.startsWith("/optometrist")) return "/vision-screening";
    if (base.startsWith("/nurse-")) return base; // nurses land on their root (e.g. /nurse-1)
    return base; // safe fallback
  })();

  const DASH = `${base}/dashboard`;

  const tabs = ["Dashboard", effectiveLabel];
  const linkForTab = (tab: string) => (tab === "Dashboard" ? DASH : secondHref);

  const onLogout = () => {
    try {
      sessionStorage.removeItem("accessToken");
      localStorage.removeItem("accessToken");
    } catch {}
    navigate("/", { replace: true });
  };

  return (
    <div className="app-header__inner">
      <img className="app-header__logo" src={Logo} alt="Qavach" />
      <div style={{ flex: 1 }}>
        <TopBar tabs={tabs} linkForTab={linkForTab} onLogout={onLogout} />
      </div>
    </div>
  );
};

export default NurseTopBar;
